import { Component, Inject, Input } from '@angular/core';

@Component({
  selector: 'app-nx-button',
  templateUrl: './nx-button.component.html',
  styleUrls: ['./nx-button.component.scss']
})
export class NxButtonComponent {

  @Input() icon: string;
  @Input() toolTip: string;
  @Input() text: string;
  @Input() disabled: boolean;
  @Input() width: string;

  public toolTipDelay;

  constructor(
    @Inject('env')private environment : any
  ) {
    this.toolTipDelay = this.environment.toolTipDelay;
  }


}
